import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import {
  FullRegistrationRequest,
  IndexFaceRequest,
  IndexFaceResponse,
  SearchFaceRequest,
  SearchFaceResponse,
} from '../models/biometria';
import { Result } from '../models/result';
import { MotoristaGerenciamentoDTO } from '../../features/biometria/models/motorista-gerenciamento';
import { UpdateDriverBiometryDTO } from '../../features/biometria/models/update-driver';

@Injectable({
  providedIn: 'root',
})
export class BiometriaService {
  apiUrl = environment.urlControlCenterApi + 'rekognition';

  constructor(private http: HttpClient) {}

  indexFace(data: IndexFaceRequest) {
    return this.http.post<Result<IndexFaceResponse>>(
      `${this.apiUrl}/partial-registration`,
      data,
    );
  }

  searchForMatchingFace(data: SearchFaceRequest) {
    return this.http.post<Result<SearchFaceResponse>>(
      `${this.apiUrl}/search-face`,
      data,
    );
  }

  getRegisteredDriver(driverId: string) {
    return this.http.get<Result<MotoristaGerenciamentoDTO>>(
      `${this.apiUrl}/registered-driver?driverId=${driverId}`,
    );
  }

  fullRegistration(data: FullRegistrationRequest) {
    return this.http.post<Result<string>>(
      `${this.apiUrl}/full-registration`,
      data,
    );
  }

  updateRegisteredDriver(data: UpdateDriverBiometryDTO) {
    return this.http.put<Result<boolean>>(
      `${this.apiUrl}/driver-biometric`,
      data,
    );
  }

  deleteRegisteredDriver(driverId: number) {
    return this.http.delete<Result<void>>(`${this.apiUrl}/${driverId}`);
  }
}
